import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../App';
import Navigation from './Navigation';
import { toast } from 'sonner';
import axios from 'axios';

const ApprovalsPageMinimal = () => {
  const { user, API } = useContext(UserContext);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);

  useEffect(() => {
    console.log('ApprovalsPageMinimal mounting...');
    loadPendingUsers();
  }, []);

  const loadPendingUsers = async () => {
    try {
      console.log('Loading pending users with API:', API);
      
      if (!user || user.role !== 'system_admin') {
        console.log('Permission denied');
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API}/users/pending?user_role=${user.role}`);
      console.log('Pending users API response:', response.data?.length);
      setPendingUsers(response.data || []);
    } catch (error) {
      console.error('Error loading pending users:', error);
      toast.error('Erreur chargement demandes');
      setPendingUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const approveUser = async (userId, approved) => {
    try {
      setActionLoading(userId);
      
      await axios.post(`${API}/users/approve`, {
        user_id: userId,
        approved: approved,
        approved_by: user.id
      });

      toast.success(approved ? 'Utilisateur approuvé !' : 'Utilisateur rejeté !');
      loadPendingUsers();
    } catch (error) {
      console.error('Approval error:', error);
      toast.error('Erreur lors de l\'action');
    } finally {
      setActionLoading(null);
    }
  };

  console.log('Rendering ApprovalsPageMinimal, loading:', loading, 'pending count:', pendingUsers.length);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #fed7aa, #fef3c7, #fde68a)', padding: '20px' }}>
        <Navigation />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '400px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              width: '40px', 
              height: '40px', 
              border: '3px solid #f97316', 
              borderTop: '3px solid transparent', 
              borderRadius: '50%', 
              animation: 'spin 1s linear infinite',
              margin: '0 auto 16px'
            }}></div>
            <p style={{ color: '#6b7280' }}>Chargement des demandes...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!user || user.role !== 'system_admin') {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #fed7aa, #fef3c7, #fde68a)', padding: '20px' }}>
        <Navigation />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '400px' }}>
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#dc2626', marginBottom: '16px' }}>
              ⛔ Accès Refusé
            </h2>
            <p style={{ color: '#6b7280' }}>
              Seul l'administrateur système peut voir les approbations.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #fed7aa, #fef3c7, #fde68a)' }}>
      <Navigation />
      
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '32px 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#111827', marginBottom: '32px' }}>
          🔍 Demandes d'Approbation
        </h1>

        <div style={{ background: 'rgba(255, 255, 255, 0.8)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', padding: '24px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '24px' }}>
            Utilisateurs en Attente ({pendingUsers.length})
          </h2>

          {pendingUsers.length > 0 ? (
            <div style={{ display: 'grid', gap: '16px' }}>
              {pendingUsers.map((pendingUser, index) => (
                <div key={pendingUser.id || index} style={{ 
                  padding: '20px', 
                  background: '#fed7aa', 
                  borderRadius: '12px', 
                  border: '1px solid #fb923c'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827' }}>
                        {pendingUser.username}
                      </h3>
                      <p style={{ color: '#6b7280', marginTop: '4px' }}>
                        Rôle: <strong>{pendingUser.role}</strong>
                      </p>
                      <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                        Demande le: {new Date(pendingUser.created_at).toLocaleDateString('fr-FR')}
                      </p>
                    </div>
                    
                    <div style={{ display: 'flex', gap: '12px' }}>
                      <button
                        onClick={() => approveUser(pendingUser.id, true)}
                        disabled={actionLoading === pendingUser.id}
                        style={{
                          padding: '8px 16px',
                          background: actionLoading === pendingUser.id ? '#9ca3af' : '#16a34a',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          fontWeight: 'bold',
                          cursor: actionLoading === pendingUser.id ? 'not-allowed' : 'pointer',
                          fontSize: '14px'
                        }}
                      >
                        {actionLoading === pendingUser.id ? 'En cours...' : '✅ Approuver'}
                      </button>
                      
                      <button
                        onClick={() => approveUser(pendingUser.id, false)}
                        disabled={actionLoading === pendingUser.id}
                        style={{
                          padding: '8px 16px',
                          background: actionLoading === pendingUser.id ? '#9ca3af' : '#dc2626',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          fontWeight: 'bold',
                          cursor: actionLoading === pendingUser.id ? 'not-allowed' : 'pointer',
                          fontSize: '14px'
                        }}
                      >
                        ❌ Rejeter
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '48px 0' }}>
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>
                ✅ Aucune demande en attente
              </h3>
              <p style={{ color: '#6b7280' }}>
                Toutes les demandes ont été traitées.
              </p>
            </div>
          )}
        </div>

        {/* Debug info */}
        <div style={{ marginTop: '20px', padding: '12px', background: '#f3f4f6', borderRadius: '8px', fontSize: '12px' }}>
          <p><strong>Debug:</strong></p>
          <p>User: {user?.username} ({user?.role})</p>
          <p>API: {API}</p>
          <p>Pending users loaded: {pendingUsers.length}</p>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ApprovalsPageMinimal;